(function(){
    'use strict';

    window.isLocal = ()=>{
        const rExp = new RegExp('^[0-9]|localhost', 'i');
        if (rExp.test(location.hostname) )
        return true;
    }
}());
